import React, { FC } from 'react';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { TimeTileProps } from '@v2/pages/common/components/NCFileBatchEvents/components/TimeTiles/components/TimeTile';
import Button from '@styles/buttons';
import { Timestamps } from '@v2/pages/common/components/NCFileBatchEvents/components/TimeTiles/types';
import Svg from '@styles/icons/svg';
import { ContainerStyle } from '@interfaces/base';
import { TIME_TILE_EDIT_ACTION_CONFIG } from '@v2/pages/common/components/NCFileBatchEvents/components/TimeTiles/constants';

export interface TimeTileEditActionsProps extends Required<Pick<TimeTileProps, 'C'>>, ContainerStyle {
  originalValue: number;
  updatedValue: number;
  onCancel: () => void;
  onConfirm: (timestamps: Timestamps) => void;
}

const TimeTileEditActions: FC<TimeTileEditActionsProps> = ({ C, onCancel, onConfirm, updatedValue, originalValue, containerStyle }) => {
  const iconSize = scale(TIME_TILE_EDIT_ACTION_CONFIG.iconSize);
  const buttonSize = scale(TIME_TILE_EDIT_ACTION_CONFIG.buttonSize);

  const buttonStyle = { width: buttonSize, height: buttonSize, borderRadius: buttonSize / 2 };

  return (
    <View style={[{ flexDirection: 'row', gap: scale(4) }, containerStyle]}>
      <Button C={C} variant="Icon Button" type="Icon Button" onPress={onCancel} loading={false} customStyle={buttonStyle}>
        <Svg icon="closeBold" width={iconSize} height={iconSize} color="Label/Light/Error" />
      </Button>

      <Button
        C={C}
        variant="Icon Button"
        type="Icon Button"
        onPress={() => onConfirm({ updatedTime: updatedValue, replacedTime: originalValue })}
        loading={false}
        customStyle={buttonStyle}
      >
        <Svg icon="check" width={iconSize} height={iconSize} color="Status/Light/Active" />
      </Button>
    </View>
  );
};

export default TimeTileEditActions;
